module.exports = __webpack_public_path__ + "static/media/empty.03dc545e.svg";